import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: process.env.REACT_APP_ADMIN_POOL_ID,
    ClientId: process.env.REACT_APP_ADMIN_CLIENT_APP_ID
}

export default new CognitoUserPool(poolData);